import IconAndLabel from '@src/basic-components/IconAndLabel/IconAndLabel';
import Reactions from '@src/components/Post/Reactions/Reactions';
import { useStoreState } from '@src/model/hooks';
import { propsEqualityFn } from '@src/utils/object-utils/object-utils';
import React, { type FC, memo } from 'react';
import CommentMenuPopover from '../CommentMenuPopover/CommentMenuPopover';
export interface CommentActionsProps {
    className?: string;
    tokenName: string;
    commentId: string;
    onReplyClick: () => void;
    onEditClick: () => void;
}

const CommentActions: FC<CommentActionsProps> = props => {
    const { tokenName, commentId, className = '', onReplyClick, onEditClick } = props;

    const renderReplyTrigger = () => {
        return <IconAndLabel iconName="chat" iconProps={{ className: 'text-lg' }} labelProps={{ className: 'text-sm' }} onClick={onReplyClick} />;
    };

    const renderMenuPopover = () => {
        return <CommentMenuPopover onEditClick={onEditClick} commentId={commentId} tokenName={tokenName} />;
    };

    return (
        <div className={`flex items-center space-x-4 h-5 ${className}`}>
            <Reactions className="text-gray-500" tokenName={tokenName} entityId={commentId} entityType="Comment" />
            {renderReplyTrigger()}
            {renderMenuPopover()}
        </div>
    );
};

export default memo(CommentActions, propsEqualityFn);
